import { useRecoilValue } from 'recoil';
import { REQ_STATUS } from 'packages/lib/common-types/types';
import { saveToApiStatusAtom } from 'packages/at-shell/state/recoil/ui';
export const AutosaveInFlightWarning = (): null => {
  const saveInFlight = useRecoilValue(saveToApiStatusAtom);
  window.onbeforeunload = (): true | null =>
    saveInFlight === REQ_STATUS.pending ? true : null;
  return null;
};
